import { withRouter } from 'react-router-dom';
import { connect } from 'react-redux';
import { getAccess, setWebViewMode, setIsFirstConnection } from '../actions/GenericActions';
import App from '../App';

export const mapStateToProps = state => ({
  login: state.choice.identities.login,
  webViewFlag: state.generic.webViewMode,
  identities: state.choice.identities,
  isFirstConnection: state.generic.isFirstConnection,
});

export const mapDispatchToProps = dispatch => ({
  getAccess: ({ qs, device }) => dispatch(getAccess({ qs, device })),
  setWebViewMode: isEnabled => dispatch(setWebViewMode(isEnabled)),
  setIsFirstConnection: isFirstConnection => dispatch(setIsFirstConnection(isFirstConnection)),
});

export default withRouter(connect(mapStateToProps, mapDispatchToProps)(App));
